import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess, setError } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'REPORTS_INCONFORMIDADE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'REPORTS_INCONFORMIDADE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro = {}) {
    return {
        type: 'REPORTS_INCONFORMIDADE_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function getLista(filtro, carregando) {
	return (dispatch, getState) => {
		dispatch(setAguardando(carregando));

    	axios.get(`${consts.API_DATALAKE_URL}/inconformidadeEvento`).then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaCards(filtro) {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_DATALAKE_URL}/inconformidadeEvento/listarCards`).then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_CARDS_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaOcorrencias(shipping_code_id) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_INCONFORMIDADE_OCORRENCIA_LISTADO',
			payload: { data: [] }
		});
    	axios.get(`${consts.API_DATALAKE_URL}/reports/ocorrencias?shipping_code_id=${shipping_code_id}${getState().auth.usuarioCarregado && getState().auth.usuarioCarregado.acesso_cliente ? '&acesso_cliente=true' : ''}`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_OCORRENCIA_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaFronteiras() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_INCONFORMIDADE_FRONTEIRA_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_DATALAKE_URL}/reports/fronteiras`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_FRONTEIRA_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaNegociadores() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_INCONFORMIDADE_NEGOCIADOR_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_DATALAKE_URL}/reports/negociadores`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_NEGOCIADOR_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaOperacoes() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_INCONFORMIDADE_OPERACAO_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_DATALAKE_URL}/operacao/listarSelect`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_OPERACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getConfiguracao() {
	return (dispatch, getState) => {
		
    	axios.get(`${consts.API_URL}/inconformidadeConfiguracao`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_INCONFORMIDADE_CONFIGURACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function alterarConfiguracao(registro) {
    return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/inconformidadeConfiguracao`, {
			...registro,
			distancia_chegada_carga: FormatUtils.formatarValorBanco(registro.distancia_chegada_carga || 0, 0),
            distancia_saida_carga: FormatUtils.formatarValorBanco(registro.distancia_saida_carga || 0, 0),
            distancia_chegada_descarga: FormatUtils.formatarValorBanco(registro.distancia_chegada_descarga || 0, 0),
            distancia_saida_descarga: FormatUtils.formatarValorBanco(registro.distancia_saida_descarga || 0, 0),
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getConfiguracao());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}